import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function editProfile (data) {
  return axios
    .put(`${CRM_API_URL}/profile`, data)
    .then((response) => response.data)
}

export default { editProfile }
